<template>
  <v-card class="rounded-lg">
    <v-data-table
      :headers="headers"
      :items="levels"
      class="elevation-1"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Difficulty</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="700px" persistent>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">New Difficulty Level</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.value"
                        label="Difficulty value"
                        filled
                        v-validate="{
                          required: true,
                          min: 0
                        }"
                        type="number"
                        name="value"
                        :error-messages="errors.collect('value')"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.name"
                        label="Difficulty name"
                        filled
                        v-validate="{
                          required: true
                        }"
                        name="name"
                        :error-messages="errors.collect('name')"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" dark @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.default="{ item }">
        <v-checkbox
          :input-value="item.default"
          label="use as default"
          @change="(e) => setDefault({ ...item, default: e })"
          dense
        />
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn
          icon
          small
          @click="editItem(item)"
        >
          <v-icon
            small
          >
            {{ mdiPencil }}
          </v-icon>
        </v-btn>
        <v-btn
          icon
          small
          @click="deleteRequest(item)"
        >
          <v-icon
            small
          >
            {{ mdiDelete }}
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <delete-dialog
      v-if="deleteDialog"
      :item="deletedItem"
      @close="deleteDialog = false"
      @confirm="deleteItem"
    />
  </v-card>
</template>

<script>
import { mdiPencil, mdiDelete } from "@mdi/js"
export default {
  components: {
    deleteDialog: () => import('@/components/dialogs/DeleteDialog.vue'),
  },
  data: () => ({
    mdiPencil,
    mdiDelete,
    dialog: false,
    deleteDialog: false,
    loading: true,
    headers: [
      {
        text: 'Name',
        value: 'name',
        sortable: false,
      },
      {
        text: 'Value',
        value: 'value',
        sortable: false,
      },
      {
        text: 'Default',
        value: 'default',
        sortable: false
      },
      {
        text: 'Actions',
        value: 'action',
        align: 'center',
        sortable: false,
      },
    ],
    levels: [],
    editedIndex: -1,
    editedItem: {
      name: '',
      value: 0
    },
    defaultItem: {
      name: '',
      value: 0
    },
    deletedItem: null
  }),
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Difficulty Level' : 'Edit Difficulty Level';
    },
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  async mounted () {
    this.fetchDifficultyLevels()
  },
  methods: {
    async fetchDifficultyLevels () {
      this.loading = true

      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/configs/telemetry/difficulty`
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.levels = data
      }

      this.loading = false
    },
    editItem (item) {
      this.editedIndex = this.levels.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    async deleteRequest (item) {
      const { data } = await this.$axios.delete(
        this.$store.getters.projectPath + '/configs/telemetry/difficulty/' + item.id
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        const index = this.levels.indexOf(item)
        this.levels.splice(index, 1)
        this.$toasted.success('Successfully deleted')
      }
    },
    async setDefault (item) {
      const levels = this.levels.map(lvl =>
        lvl.id == item.id && item.default ? item : { ...lvl, default: false}
      )

      const { data } = await this.$axios.put(
        this.$store.getters.projectPath + '/configs/telemetry/difficulty',
        levels
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.levels = levels
        this.$toasted.success('Successfully changed default difficulty level')
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      this.$validator.validateAll().then(async res => {
        if (res) {
          try {
            if (this.editedIndex > -1) {
              await this.updateDicficultyLevel()
            } else {
              await this.createDifficultyLevel()
            }
          } catch(err) {
            console.log(err.message);
          }
          this.close();
        }
      })
    },
    async createDifficultyLevel () {
      const { data } = await this.$axios.post(
        this.$store.getters.projectPath + '/configs/telemetry/difficulty',
        { ...this.editedItem }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.levels.push(data)
        this.$toasted.success('Successfully created')
        this.close()
      }
    },
    async updateDicficultyLevel () {
      const { data } = await this.$axios.put(
        this.$store.getters.projectPath + '/configs/telemetry/difficulty/' + this.editedItem.id,
        this.editedItem
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.$set(this.levels, this.editedIndex, data)
        this.$toasted.success('Successfully updated')
        this.close()
      }
    }
  },
}
</script>
